/* EclatDent — accueil immersif : parallaxe héro, chapitres épinglés, galerie packs, apparitions */
(() => {
  if (window.__edimInit) return;
  window.__edimInit = true;

  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

  // — Apparition des cartes chiffres + compteur animé —
  const countUp = (el) => {
    if (reduced || el.dataset.counted) return;
    const raw = el.textContent;
    const m = raw.match(/(\d+(?:[.,]\d+)?)/); // premier nombre (virgule décimale gérée)
    if (!m) return;
    const before = raw.slice(0, m.index);
    const after = raw.slice(m.index + m[1].length);
    // On n'anime que les chiffres « purs » (prix, %) : pas ceux entourés de mots
    // (« Dès 2 tubes » resterait figé pour éviter « Dès 1 tubes » en transitoire).
    if (/[a-zà-ÿ]{2,}/i.test(before + after)) return;
    el.dataset.counted = '1';
    const target = parseFloat(m[1].replace(',', '.'));
    const decimals = (m[1].split(/[.,]/)[1] || '').length;
    const fmt = (v) => before + v.toFixed(decimals).replace('.', ',') + after;
    const dur = 900;
    const t0 = performance.now();
    const step = (t) => {
      const p = Math.min(1, (t - t0) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * eased);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = fmt(target);
    };
    requestAnimationFrame(step);
  };
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        const n = e.target.querySelector('.n');
        if (n) countUp(n);
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.25 });
  document.querySelectorAll('.edim-stat').forEach((s) => io.observe(s));
  // — 02/11/2026 (perf) : les packshots des chapitres (8 PNG de 520 px, ~510 Ko) ne se chargent plus au démarrage.
  //   Ils étaient en background-image dès le HTML et partaient avec le CSS et les polices. Désormais posés à
  //   l'approche du chapitre (1,5 écran avant). Sans IntersectionObserver : posés tout de suite.
  const lazyBg = [...document.querySelectorAll('[data-edim-img]')];
  const poser = (el) => { if (el.dataset.edimImg) { el.style.setProperty('--img', 'url(' + JSON.stringify(el.dataset.edimImg) + ')'); delete el.dataset.edimImg; } };
  if ('IntersectionObserver' in window && lazyBg.length) {
    const lio = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        const story = e.target;
        story.querySelectorAll('[data-edim-img]').forEach(poser);
        lio.unobserve(story);
      });
    }, { rootMargin: '150% 0px' });
    new Set(lazyBg.map((el) => el.closest('[data-edim-story], section') || el)).forEach((s) => lio.observe(s));
  } else lazyBg.forEach(poser);

  if (reduced) return;

  let mouseX = 0, mouseY = 0;

  // — 02/11/2026 (perf) : mesures mises en cache. Avant, chaque image de la boucle relisait
  //   getBoundingClientRect / offsetHeight de chaque chapitre (mise en page forcée 60 fois par seconde
  //   pendant le chargement : 2,5 s de CPU mobile au démarrage selon Lighthouse). On mesure au démarrage
  //   (après le premier rendu), au redimensionnement et quand la page change de hauteur.
  const metrics = new Map();
  const mesurer = (el) => { const r = el.getBoundingClientRect(); metrics.set(el, { top: r.top + scrollY, h: el.offsetHeight }); };
  const m = (el) => metrics.get(el) || (mesurer(el), metrics.get(el));
  const inView = (el) => {
    const { top, h } = m(el);
    return top + h > scrollY - innerHeight * 0.2 && top < scrollY + innerHeight * 1.2;
  };

  // — Héro : constellation de tubes en parallaxe (souris + scroll) —
  const hero = document.querySelector('[data-edim-hero]');
  const orbs = (hero ? [...hero.querySelectorAll('.edim-orb')] : []).map((el) => ({
    el,
    depth: parseFloat(getComputedStyle(el).getPropertyValue('--depth')) || 0.5,
  }));
  let hx = 0, hy = 0;
  function heroFrame() {
    if (!inView(hero)) return;
    hx += (mouseX - hx) * 0.05;
    hy += (mouseY - hy) * 0.05;
    const drift = scrollY * -0.1;
    orbs.forEach(({ el, depth }) => {
      el.style.translate = (hx * depth * 26) + 'px ' + (hy * depth * 16 + drift * depth) + 'px';
    });
  }

  // — Chapitres épinglés —
  const stories = [...document.querySelectorAll('[data-edim-story]')].map((story) => ({
    story,
    scene: story.querySelector('.edim-scene'),
    sticky: story.querySelector('.edim-sticky'),
    ghost: story.querySelector('.edim-ghost'),
    tubes: [...story.querySelectorAll('.edim-tube')],
    panels: [...story.querySelectorAll('.edim-panel')],
    dots: [...story.querySelectorAll('.edim-rail i')],
    start: parseInt(story.dataset.edimStart, 10) || 1,
    chap: 0,
    curX: 0,
  })).filter((s) => s.scene && s.panels.length);
  stories.forEach((s) => {
    s.tints = s.tubes.map((t) => t.dataset.tint || 'rgba(74,144,226,0.25)');
    s.sticky.style.setProperty('--edim-tint', s.tints[0]);
  });

  function storyFrame(s) {
    if (!inView(s.story)) return;
    const vh = innerHeight;
    const { top, h } = m(s.story);
    const n = s.panels.length;
    const p = clamp((scrollY - top) / (h - vh), 0, 1);
    const f = p * (n - 0.001);
    const i = Math.floor(f);
    const sub = f - i;

    if (i !== s.chap) {
      s.chap = i;
      s.tubes.forEach((t, k) => t.classList.toggle('is-on', k === i));
      s.dots.forEach((d, k) => d.classList.toggle('on', k === i));
      const num = s.start + i;
      if (s.ghost) s.ghost.textContent = (num < 10 ? '0' : '') + num;
      s.sticky.style.setProperty('--edim-tint', s.tints[i]);
    }

    s.curX += (mouseX - s.curX) * 0.06;
    const rotY = (sub - 0.5) * 26 + s.curX * 8;
    const rotX = Math.sin(sub * Math.PI) * -4;
    const scale = 1 + Math.sin(sub * Math.PI) * 0.045;
    s.scene.style.transform = 'rotateY(' + rotY + 'deg) rotateX(' + rotX + 'deg) scale(' + scale + ')';

    s.panels.forEach((panel, k) => {
      const d = f - (k + 0.5);
      // Pente raide : opacité nulle dès |d| ≥ 0,5 → deux panneaux ne sont jamais
      // lisibles en même temps (le crossfade doux superposait les textes en mobile).
      const op = clamp(1.3 - Math.abs(d) * 2.6, 0, 1);
      panel.style.opacity = op;
      panel.style.pointerEvents = op > 0.35 ? 'auto' : 'none';
      panel.style.transform = 'translateY(' + clamp(d * -46, -46, 46) + 'px)';
    });

    if (s.ghost) s.ghost.style.translate = '0 ' + (-54 + p * 10) + '%';
  }

  // — Galerie packs : translation horizontale pilotée par le scroll (desktop) —
  const packs = [...document.querySelectorAll('[data-edim-packs]')].map((root) => ({
    root,
    track: root.querySelector('[data-edim-track]'),
    bar: root.querySelector('[data-edim-progress]'),
    max: 0,
  })).filter((g) => g.track);

  function packsFrame(g) {
    if (innerWidth <= 860 || !inView(g.root)) return;
    const vh = innerHeight;
    const { top, h } = m(g.root);
    const p = clamp((scrollY - top) / (h - vh), 0, 1);
    g.track.style.transform = 'translateX(' + (-p * g.max) + 'px)';
    if (g.bar) g.bar.style.transform = 'scaleX(' + p + ')';
  }

  const toutMesurer = () => {
    if (hero) mesurer(hero);
    stories.forEach((s) => mesurer(s.story));
    packs.forEach((g) => { mesurer(g.root); g.max = Math.max(0, g.track.scrollWidth - g.track.clientWidth); });
  };

  // La boucle ne démarre qu'au premier geste (défilement, souris, toucher) ou au repos du navigateur après
  // le chargement : rien ne bouge avant, donc rien à calculer pendant que la page se peint. Elle se met
  // en veille ~1,5 s après la dernière activité (le lissage a convergé).
  let lastScroll = -1;
  let lastMx = 99;
  let lastMy = 99;
  let idleFrames = 0;
  let running = false;
  function loop() {
    const changed = scrollY !== lastScroll || Math.abs(mouseX - lastMx) > 0.001 || Math.abs(mouseY - lastMy) > 0.001;
    if (changed) idleFrames = 0;
    if (idleFrames++ < 90) {
      if (hero && orbs.length) heroFrame();
      stories.forEach(storyFrame);
      packs.forEach(packsFrame);
      lastScroll = scrollY; lastMx = mouseX; lastMy = mouseY;
      requestAnimationFrame(loop);
    } else running = false;
  }
  const reveiller = () => {
    if (!metrics.size) toutMesurer();
    if (!running) { running = true; idleFrames = 0; requestAnimationFrame(loop); }
  };
  addEventListener('pointermove', (e) => {
    mouseX = (e.clientX / innerWidth - 0.5) * 2;
    mouseY = (e.clientY / innerHeight - 0.5) * 2;
    reveiller();
  }, { passive: true });
  addEventListener('scroll', reveiller, { passive: true });
  addEventListener('touchstart', reveiller, { passive: true });
  addEventListener('resize', () => { toutMesurer(); reveiller(); }, { passive: true });
  if ('ResizeObserver' in window) {
    let rT = 0;
    new ResizeObserver(() => { clearTimeout(rT); rT = setTimeout(() => { if (metrics.size) toutMesurer(); }, 150); }).observe(document.body);
  }
  // Page rechargée au milieu (ancre, retour arrière) : placer les chapitres sans attendre un geste
  const auRepos = window.requestIdleCallback || ((f) => setTimeout(f, 300));
  addEventListener('load', () => auRepos(() => { toutMesurer(); if (scrollY > 0) reveiller(); }), { once: true });
})();
